import IRequest from "../../IRequest";

export interface IOperacoes {
    reqTiposDocumentos: IRequest<TOperacoesCCO>,
    dataTiposDocumentos: TOperacoesCCO[]
  }

export type TOperacoesCCO = {
  id: number;
  nome: string;
  codigo_contabil_operacao: number;
  categoria_id: number;
  conta_contabil_juros: number;
  conta_contabil_desconto: number;
  conta_contabil_credito: number;
}

export const defValueOperacoesCCO= {
    id: 0,
    nome: '',
    codigo_contabil_operacao: 0,
    categoria_id: 0,
    conta_contabil_juros: 0,
    conta_contabil_desconto: 0,
    conta_contabil_credito: 0,
}